import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, of, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CatEmployeeJobModel } from 'src/app/model/cat-employee-job.model';
import { CatProductCategoryModel } from 'src/app/model/cat-product-category.model';
import { ComProductCategoryModel } from 'src/app/model/com-product-category.model';
import { HMGenericCatalog } from 'src/app/model/hypermatrix-catalogs-models';
import { CatalogModel } from 'src/app/model/other-catalogs-models';
import { CatCategoryProductService } from 'src/oldApp/services/cat-category-product.service';
import { CatEmployeeJobService } from 'src/app/services/cat-employee-job.service';
import { ComProductCategoryService } from 'src/oldApp/services/com-product-category.service';
import { HypermatrixCatalogsService } from 'src/app/services/hypermatrix-catalogs.service';
import { VwCommissionConfiguratorService } from 'src/app/services/vw-commission-configurator.service';

@Component({
  selector: 'app-modal-sc-product-category',
  templateUrl: './modal-sc-product-category.component.html',
  styleUrls: ['./modal-sc-product-category.component.css']
})
export class ModalScProductCategoryComponent implements OnInit {
  @Input() category:ComProductCategoryModel;
  @Input() page:string;
  @Input() mode:string;
  @Input() categories:ComProductCategoryModel[]=[];

  // estado pagina
  public viewStatus:number=1;
  public formIsLocked:boolean=false;

  // catalogos
  public productCategoryCatalog:CatalogModel[]=[];
  public employeeJobCatalog:CatalogModel[]=[];
  public paymentCatalog:CatalogModel[]=[];

  // mascaras
  public customPatterns={
    'A':{pattern:new RegExp('[a-zA-Z0-9ñÑ ]')},                     // inputs regulares
    'C':{pattern:new RegExp('[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ,._:%\/() \-]')},       // comentarios (acepta acentos, comas y puntos)
    'N':{pattern:new RegExp('[0-9]')} 
  };

  /////////////////
  constructor(
    private comProductCategoryService:ComProductCategoryService,
    private catProductCategoryService:CatCategoryProductService,
    private catEmployeeJobService:CatEmployeeJobService,
    private vwCommissionConfiguratorService:VwCommissionConfiguratorService,
    private modalService: NgbModal,
    private toastr:ToastrService
  ) { }
  ngOnInit() {
    this.getCatalogs();
  }

  //
  updateProductCategory=()=> {}
  updateEmployeeJob=()=> {}
  updatePayment=()=> {}
  updateCommission=e=> this.category.commission=Number(e);
  toggleActive=()=> this.category.activeId=!this.category.activeId;
  isValid=()=> {
    let valid=true;
    let errors=[];
    if(this.productCategoryError()) errors.push('Necesita seleccionar una categoría.');
    if(this.employeeJobError()) errors.push('Necesita seleccionar un puesto.');
    if(this.paymentError()) errors.push('Necesita seleccionar un plazo.');
    if(this.commissionError()) errors.push('Necesita capturar una comisión.');
    if(this.existsError()) errors.push('La categoría seleccionada, ya existe!');
    console.log(this.paymentError()+" - "+this.commissionError());

    if(errors.length>0) {
      valid=false;
      this.toastr.error(errors.join('<br>'), '¡Atención!', {enableHtml:true});
    }
    return valid;
  }
  save=()=> {
    if(this.isValid()) {
      // mostrar spinner
      this.viewStatus=0;
      // enviar informacion
      this.comProductCategoryService.save(this.category)
        .pipe(
          tap((resp:any)=> {
            console.log(resp);
            this.modalService.dismissAll('success');
            this.toastr.success('La categoría se guardó con éxito.');
          }),
          catchError(error=> {
            console.log(error);
            this.modalService.dismissAll('failure');
            return of(this.toastr.error('Ocurrió un error al intentar guardar la categoría.'));
          })
        )
        .subscribe();
    }
  }
  close=()=> this.modalService.dismissAll();

  // HELPERS
  productCategoryError=()=> !this.category.productCategoryId;
  employeeJobError=()=> !this.category.employeeJobId;
  paymentError=()=> !this.category.paymentId;
  commissionError=()=> this.category.commission==0 || !this.category.commission;
  existsError=()=>{
    let exists = false;
    let categoriesFiltered = this.categories.filter(ca => ca.commissionProductCategoryId !== this.category.commissionProductCategoryId);
    categoriesFiltered.forEach((ca)=>{
      if(ca.productCategoryId === this.category.productCategoryId &&
         ca.employeeJobId === this.category.employeeJobId &&
         ca.paymentId === this.category.paymentId &&
         ca.activeId === this.category.activeId)
        exists = true;
    });
    return exists;
  }

  // INFO
  getCatalogs=()=> {
    forkJoin(
      this.catProductCategoryService.catalog(),
      this.catEmployeeJobService.catalog(),
      this.vwCommissionConfiguratorService.getPayments()
    )
    .pipe(
      tap(([catProdResp, catEmpJobResp, paymentResp]:[any, any, any])=> {
        if(catProdResp && catEmpJobResp && paymentResp) {
          this.productCategoryCatalog=catProdResp.data;
          this.employeeJobCatalog=catEmpJobResp.data;
          this.paymentCatalog=paymentResp.data;
          this.viewStatus=1;
        }
        else throwError;
      }),
      catchError(error=> {
        console.log(error);
        this.viewStatus=-1;
        return of(this.toastr.error('Ocurrió un error al leer los catálogos.'));
      })
    )
    .subscribe();
  }
}
